import {
    Box,
    FormControl,
    FormErrorMessage,
    FormLabel, IconButton,
    Input, InputGroup, InputLeftAddon, InputRightElement
} from '@chakra-ui/react';
import {FormikContext, useField} from 'formik';
import React, { useContext, useRef } from 'react';
import {CalendarIcon, TimeIcon} from "@chakra-ui/icons";

const pathExists = (obj, path) => {
    if (!obj || !path) return false;
    return path.split('.').every(k => (obj = obj?.[k]) !== undefined);
};

const InlineErrorInput = ({ name, label, flex, isRequired = false, type = 'text', value, onChange, onBlur, error, touched, useFormik = true, isDisabled = false, leftAddon, ...props }) => {
    const formik = useContext(FormikContext);
    const inFormik = !!(useFormik && formik && name && pathExists(formik.values, name));

    const fieldProps = inFormik ? formik.getFieldProps(name) : { value, onChange, onBlur };
    const meta = inFormik ? formik.getFieldMeta(name) : { error, touched };

    const showError = !!(meta.touched && meta.error);
    const ref = useRef(null);

    const openPicker = () => {
        try { (ref.current)?.showPicker?.(); } catch {}
        ref.current?.focus();
    };

    return (
        <FormControl isInvalid={showError} isRequired={isRequired} isDisabled={isDisabled} flex={flex}>
            <FormLabel htmlFor={name}>{label}</FormLabel>
            <Box position="relative">
                <InputGroup>
                    {leftAddon !== undefined && (
                        <InputLeftAddon>
                            {typeof leftAddon === 'string' ? leftAddon : leftAddon}
                        </InputLeftAddon>
                    )}
                    <Input
                        id={name}
                        type={type}
                        name={name}
                        ref={ref}
                        pr="48px"
                        aria-invalid={showError ? 'true' : undefined}
                        aria-describedby={showError ? `${name}-error` : undefined}
                        css={{"::-webkit-calendar-picker-indicator": { opacity: 0, pointerEvents: "none" }}}
                        {...fieldProps} {...props}/>
                    {showError && (
                        <Box
                            id={`${name}-error`}
                            position="absolute"
                            top="4px"
                            right="6px"
                            textAlign={"right"}
                            color="red.500"
                            fontSize="xs"
                            zIndex={1}
                            pointerEvents="none">
                            {meta.error}
                        </Box>
                    )}
                    {(type === 'date' || type === 'time') &&
                        <InputRightElement width={showError ? '20px' : '40px'} alignItems={showError ? "flex-end" : "center"}>
                            <IconButton
                                aria-label={type === "date" ? "Wybierz datę" : "Wybierz godzinę"}
                                icon={type === "date" ? <CalendarIcon /> : <TimeIcon />}
                                variant="ghost"
                                size="sm"
                                onClick={openPicker}
                                tabIndex={-1}
                                alignItems={showError ? "flex-end" : "center"}
                                pb={showError ? '5px' : 0}
                            />
                        </InputRightElement>
                    }
                </InputGroup>
            </Box>
        </FormControl>
    );
};

export default InlineErrorInput;
